import type {
  FaceWidthMeasurementEntrySource,
  FaceWidthMeasurementRequest,
  PdMeasurementEntrySource,
  PdMeasurementRequest,
  PrescriptionPdMeasurementRisk,
} from './types';

export const FACE_WIDTH_MEASUREMENT_REQUEST_EVENT = 'zeelool:face-width-measurement-request';

export function requestFaceWidthMeasurement(
  source: FaceWidthMeasurementEntrySource,
  target: Pick<EventTarget, 'dispatchEvent'> = window,
) {
  const request: FaceWidthMeasurementRequest = { kind: 'face-width', source };
  target.dispatchEvent(
    new CustomEvent<FaceWidthMeasurementRequest>(FACE_WIDTH_MEASUREMENT_REQUEST_EVENT, {
      detail: request,
    }),
  );
}

export const PD_MEASUREMENT_REQUEST_EVENT = 'zeelool:pd-measurement-request';

export function requestPdMeasurement(
  source: PdMeasurementEntrySource,
  target: Pick<EventTarget, 'dispatchEvent'> = window,
  prescriptionRisk?: PrescriptionPdMeasurementRisk,
) {
  const request: PdMeasurementRequest = {
    kind: 'pd',
    source,
    ...(prescriptionRisk ? { prescriptionRisk } : {}),
  };
  target.dispatchEvent(
    new CustomEvent<PdMeasurementRequest>(PD_MEASUREMENT_REQUEST_EVENT, {
      detail: request,
    }),
  );
}
